import View from "backdraft-app/src/view";

import "shared/jquery/help_popover";

import template from "./target_area_locator/template.jst";

import CitySearch from "../city_search";

export default class TargetAreaLocator extends View {
  get events() {
    return {
      "click :checkbox#radius-field-checked": "_onRadiusFieldCheckboxChange"
    };
  }

  initialize(options) {
    super.initialize(options);
    this.options = options || {};
  }

  render() {
    this.$el.html(template({
      targetAreaInputDisabled:     this.options.disabled,
      radiusCheckboxDisabled:      this.options.disabled,
      radiusDistanceInputDisabled: this.options.disabled || !this.radiusChecked()
    }));
    this._wireVeryLocalNumberPopover();
    CitySearch.formTypeaheadSetup(this.$('#target-area-text-field'));
    return this;
  }

  getLocation() {
    return this.$('#target-area-text-field').val();
  }

  setLocation(location) {
    return this.$('#target-area-text-field').val(location);
  }

  radiusChecked() {
    return this.$("#radius-field-checked").is(":checked");
  }

  checkRadius() {
    this.$('#radius-field-checked').attr('checked', true);
  }

  uncheckRadius() {
    this.$('#radius-field-checked').attr('checked', false);
  }

  getRadius() {
    return this.$("#radius-distance").val();
  }

  setRadius(radius) {
    this.$('#radius-distance').val(radius);
  }

  setRadiusInputDisabledProp(disabled) {
    this.$('#radius-distance').prop("disabled", disabled);
  }

  _wireVeryLocalNumberPopover() {
    this.$("[data-mount='very-local-number-popover']").helpPopover({
      placement: "bottom",
      content: "Specifying either a zip code or a local prefix (NPA-NXX) will allow us to search for phone numbers in a more specific target area, if any are available."
    });
  }

  _onRadiusFieldCheckboxChange() {
    this.setRadiusInputDisabledProp(!this.radiusChecked());
  }
}
